export default __webpack_public_path__ + "static/media/IMG_9419.b8ace91c.JPG";